module.exports = __webpack_public_path__ + "img/珠海万菱环球中心.3d8ac717.png";